module.exports = __webpack_public_path__ + "static/media/img-heritage-area5-mietsu.3ad90ac8.jpg";